import { subjects as defaultSubjects } from '@sopranodesign/pulse-conditionals';
import { subjects as integrationSubjects } from '@sopranodesign/pulse-integrations';
import { subjects as importSubjects } from '@sopranodesign/pulse-import';

const composers = [
  defaultSubjects.event,
  ...defaultSubjects.subjects,
  integrationSubjects.conditionals.integration,
  integrationSubjects.conditionals.lookup,
  integrationSubjects.conditionals.variable,
  importSubjects.conditionals.section
];

export default composers;
